<template>
  <div class="item-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "itemBase",
};
</script>
